import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class FlightPtbrsEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      id: '',
      name: '',
      reason: '',
      code: '',
      type: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.locale = getLocale();

    this.edit = this.edit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if(newProps.modal_props === true && this.state.loaded == 0) {
        this.setState({
          modal: true,
          loaded: 1,
          type: newProps.data_flight_ptbr.type,
          code: newProps.data_flight_ptbr.code,
          name: newProps.data_flight_ptbr.name,
          reason: newProps.data_flight_ptbr.reason,
          id: newProps.data_flight_ptbr.id,
        });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
      reason: this.state.reason,
      code: this.state.code,
      type: this.state.type,
      id: this.state.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/justificativa/atraso', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  closeModal(responseJson) {
    this.setState({
      loaded: 0,
      modal: false,
    });
    this.props.closeModal();
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.tituloEditarJustificativaDeAtrasoPTBR}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.edit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.Nome}:</label>
                    <input type="text" name="name" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.placeholder.Nome} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.Motivo}:</label>
                    <input type="text" name="reason" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.placeholder.Motivo} value={this.state.reason} onChange={this.handleChange.bind(this, 'reason')} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.Codigo}:</label>
                    <input type="text" name="code" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.placeholder.Codigo} value={this.state.code} onChange={this.handleChange.bind(this, 'code')} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.Tipo}:</label>
                    <Select
                      className="form-field-name"
                      name="type"
                      value={this.state.type}
                      searchable={true}
                      placeholder={this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.placeholder.SelecioneTipo}
                      onChange={this.handleSelectChange.bind(this, 'type')}
                      options={[
                        {value: "departure", label: this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.opcoesTipo.Decolagem},
                        {value: "flight", label: this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.opcoesTipo.TempoDeVoo},
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabJustificativasDeAtraso.formularioEditarJustificativaDeAtrasoPTBR.botaoEditarJustificativaDeAtrasoPTBR}</button>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default FlightPtbrsEditModal;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/FlightPtbrsEditModal.js